<div class="row text-center animated fadeIn">
    <div class="col">
        <i class="fas fa-sync fa-spin fa-5x"></i>
    </div>
</div>